import React from 'react'
import system from 'system-components'

const Wrap = system({
  mx: 'auto',
  maxWidth: 'small',
})

const Container = system({
  px: [4],
})

const ContainerWrap = ({ children, maxWidth, ...rest }) => (
  <Container {...rest}>
    <Wrap maxWidth={maxWidth}>
      {children}
    </Wrap>
  </Container>
)

Wrap.displayName = 'Wrap'
Container.displayName = 'Container'

export default ContainerWrap



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Container.js